<script lang="ts">
import { computed, ref } from 'vue';

import {
  PhxsgVideoPlayer as PhxsgCoreVideoPlayer,
  type PhxsgVideoPlayerProps as PhxsgCoreVideoPlayerCoreProps,
  type VideoSource,
  type VideoCaption,
  type VideoFit,
} from '@sg-core/src/View/Components/Molecules/VideoPlayer';

import { PhxsgButton } from '../../Atoms/Button';

export interface PhxsgVideoPlayerProps extends PhxsgCoreVideoPlayerCoreProps {
  buttonColor?: 'black' | 'white';
}

export type { VideoSource, VideoCaption, VideoFit };
</script>

<script setup lang="ts">
const { buttonColor = 'black', tapToToggle = true, ...coreProps } = defineProps<PhxsgVideoPlayerProps>();

const coreVideoPlayerRef = ref<InstanceType<typeof PhxsgCoreVideoPlayer> | null>(null);
const playerElement = computed(() => coreVideoPlayerRef.value?.playerElement ?? null);
const player = computed(() => coreVideoPlayerRef.value?.player ?? null);

defineExpose({ playerElement, player });
</script>

<template>
  <PhxsgCoreVideoPlayer ref="coreVideoPlayerRef" :tap-to-toggle="tapToToggle" v-bind="coreProps">
    <slot />

    <template #play-button>
      <div class="phxsg-video-player__play-overlaid">
        <PhxsgButton
          :class="{ 'phxsg-theme-dark': buttonColor === 'white' }"
          variant="plain"
          color="primary"
          :icon-only="true"
          icon-id="play"
        />
      </div>
    </template>
  </PhxsgCoreVideoPlayer>
</template>

<style src="./video-player.css" />
